import { ROUTES } from "./path"
import React from "react"
import { AppRouteConfig } from "@/types/navigation"
import Playground from "@/pages/dashboard/enrichment"

export const enrichmentRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.PLAYGROUND,
    element: React.createElement(Playground),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
]
